<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			(setDialogHide) => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">Thông tin khớp lệnh #{{id}}</h4>
			<!-- <p class="text-base text-black font-medium">{{ data.device ? data.device.name : "" }}</p> -->
		</div>
		<!-- <PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings"> -->
		<div>
			<div class="p-6" v-if="isPopupActiveLocal">
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Chủng loại hàng hóa
					</label>
					<cbs-input type="text" v-model="product_name" class="w-full" readOnly />
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Khối lượng (kg)
					</label>
					<cbs-input type="number" v-model="quantity" class="w-full" readOnly />
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Tên nhà cung cấp
					</label>
					<cbs-input type="text" v-model="supplier_name" class="w-full" readOnly />
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Điện thoại
					</label>
					<cbs-input type="text" v-model="supplier_phone" class="w-full" readOnly />
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Địa chỉ kho
					</label>
					<cbs-input type="text" v-model="supplier_address" class="w-full" readOnly />
				</div>
				<div class="mb-5">
					<label for class="text-base vs-input--label">
						Địa chỉ nhận hàng
					</label>
					<cbs-input type="text" v-model="cus_address" class="w-full" readOnly />
				</div>
			</div>

			<div class="grid grid-cols-2" style="background-color: #F2F2F2;">
					<div class="p-6">
						<label class="text-base vs-input--label">Thông tin vận đơn</label>
					</div>
					<div style="padding-top: 16px; padding-right: 1.5rem; text-align: right;" v-if="canCreateShipping && !shipping_done">
						<button @click="toogleAddShipping()">
							<i class="material-icons">add</i>
						</button>
					</div>
				</div>
			<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
				<vs-table :sst="true" class="shadow-none border-none custom-vs-table" fixed responsive :data="shippings">
					<template slot="thead">
						<vs-th>Thời gian</vs-th>
						<vs-th>Khối lượng</vs-th>
						<vs-th>Phương tiện</vs-th>
						<vs-th>Biển số</vs-th>
						<vs-th>Tài xế</vs-th>
						<vs-th>Điểm đến</vs-th>
						<vs-th></vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data" @click.native="handleClickItemRow(tr)">
							<vs-td>{{tr.shipping_date}}</vs-td>
							<vs-td>{{$helper.numFormat(tr.quantity)}}</vs-td>
							<vs-td>{{tr.vehicle_type == 1 ? 'Xe tải' : 'Ghe'}}</vs-td>
							<vs-td>{{tr.vehicle_no}}</vs-td>
							<vs-td>{{tr.driver_name}}</vs-td>
							<vs-td>{{tr.address}}</vs-td>
							<vs-td>
								<div id="test" style="cursor: pointer" class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap ml-3" @click.stop="printOrder(tr, $event)">
									<i class="nucleo mr-1 text-primary nucleo-file-text" />
									<span class="label text-primary">In phiếu</span>
								</div>
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
		<div style="height:30px;"></div>
			</PerfectScrollbar>
		<!--</PerfectScrollbar>-->
		</div>

		<div class="flex justify-center" slot="footer" v-if="canDoneShipping && !shipping_done">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData" >Kết thúc đơn hàng</vs-button>
		<div style="height:30px;"></div>
		</div>
		<ShippingForm :isPopupActive="isDetailUserDialogActive" @closePopup="toggleDetailSidebar" :data="detailUserDialogData" />
		<KcsRatingForm :isPopupActive="isKcsRatingDialogActive" @closePopup="toggleKcsSidebar" :data="kcsRatingDialogData" />
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import ShippingForm from "./ShippingForm.vue";
import KcsRatingForm from "./KcsRatingForm.vue";

export default {
	name: "KcsForm",
	components: { vSelect, ShippingForm, KcsRatingForm },
	props: {
		isPopupActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			timeKey: Date.now(),
			id: null,
			product_name: null,
			quantity: null,
			supplier_name: null,
			supplier_phone: null,
			supplier_address: null,
			shipping_done: false,
			shippings: [],
			cus_address: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			isDetailUserDialogActive: false,
			detailUserDialogData: {},
			canCreateShipping: false,
			canDoneShipping: false,
			isKcsRatingDialogActive: false,
			kcsRatingDialogData: {},
			buy_address: '',
			userToken: '',
		};
	},
	watch: {
		isPopupActive(val) {
			console.log('isPopupActive: ', val);
			if (!val) return;

			const { id } = this.data;

			if (id) {
				this.id = id;
				this.getMatching();
			} else {
				this.id = null;
			}

			this.isFormDirty = false;
			this.initFormData = {};
		},

		computedFormData: {
			handler: function (newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true,
		},
		city() {
			if (this.city) {
				this.$store.dispatch("getDistrict", {
					provinceCode: this.city,
				});
			}
		},
		district() {
			if (this.district) {
				this.$store.dispatch("getWard", {
					districtCode: this.district,
				});
			}
		},
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			},
		},
		// computedFormData() {
		// 	return {
		// 		id: this.id,
		// 		fullName: this.fullName,
		// 		nickname: this.nickname,
		// 		phone: this.phone,
		// 		city: this.city,
		// 		district: this.district,
		// 		ward: this.ward,
		// 		street: this.street,
		// 		assigned: this.assigned,
		// 		totalPool: this.totalPool,
		// 	};
		// },
	},
	created() {
		if (this.$store.state.AppActiveUser) {
			let { permissions = {}, token } = this.$store.state.AppActiveUser;
			let { shipping_can_create = false, shipping_can_done = false, shipping_can_rating = false } = permissions;
			if (shipping_can_create) {
				this.canCreateShipping = true;
			}
			if (shipping_can_done) {
				this.canDoneShipping = true;
			}
			if (shipping_can_rating) {
				this.canRatingShipping = true;
			}
			this.userToken = token;
		}
	},
	methods: {
		printOrder(item) {
			console.log(item);
			// return;
            // var divContents = document.getElementById("test").innerHTML;
            var a = window.open(process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT+'/api/shipping-print/'+item.id+'?token='+this.userToken, '', 'height=500, width=880');
            // a.document.write('<html>');
            // a.document.write('<body > <h1>Div contents are <br>');
            // a.document.write(divContents);
            // a.document.write('</body></html>');
            // a.document.close();
			// a.focus();
            // a.print();

			// a.addEventListener('load', function() {
			// 	a.print();
			// 	a.close();
			// }, true);
        },
		handleClickItemRow(item) {
			// if (this.canCreateShipping) {
				this.detailUserDialogData = item;
				this.isDetailUserDialogActive = true;
			// } else if (this.canRatingShipping) {
			// 	this.kcsRatingDialogData = item;
			// 	this.isKcsRatingDialogActive = true;
			// }
		},
		toggleKcsSidebar() {
			this.isKcsRatingDialogActive = !this.isKcsRatingDialogActive;
		},
		toggleDetailSidebar() {
			this.isDetailUserDialogActive = !this.isDetailUserDialogActive;
			if (!this.isDetailUserDialogActive) {
				this.getMatching();
			}
		},
		toogleAddShipping() {
			this.isDetailUserDialogActive = !this.isDetailUserDialogActive;
			this.detailUserDialogData = {
				match_id: this.id,
				buy_address: this.buy_address,
			};
		},
		getSuppliers() {
			// this.$vs.loading();
			try {
				let payload = {
				};
				this.$store.dispatch("moduleProduct/fetchSuppliers", payload);
				this.getGetUsers();
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		getMatching() {
			this.id = this.data ? this.data.id : null;
			if (!this.id) {
				return;
			}
			// this.$vs.loading();
			try {
				this.$store.dispatch("moduleProduct/getMatching", this.id).then(response => {
					let {shippings, product, quantity, supplier_name, supper_phone, seller_address, buy, shipping_done, cus_address} = response;
					this.shippings = shippings;
					this.product_name = product ? product.name : '';
					this.buy_address = buy ? buy.address : '';
					this.quantity = quantity;
					this.supplier_name = supplier_name;
					this.supplier_phone = supper_phone;
					this.supplier_address = seller_address;
					this.shipping_done = shipping_done;
					this.cus_address = cus_address;

				}).catch(err => console.log);
				// this.$vs.loading.close();
			} catch (error) {
				console.log(error.message);
				// this.$vs.loading.close();
			}
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.supplier_name = null;
			this.supper_phone = null;
			this.supper_mst = null;
			this.supplier_bankaccount = null;
			this.supplier_bankname = null;
			this.supplier_bankowner = null;
			this.address = null;
			this.supplier = null;
			this.cus_note = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						id: this.id,
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			if (this.supplier == 0) {
				this.getSuppliers();
			}
			if (!this.id) {
				this.initValues();
			}
			// if (this.id) {
			// 	this.$emit("closePopup");
			// }
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đã lưu hoàn thành vận đơn",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/doneShipping", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				// this.$helper.notifyError({ context: this, error });
				this.$helper.notifyError({ context: this, options: {
					text: error,
				} });
			} finally {
				this.$vs.loading.close();
			}
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
};
</script>

<style>
	.custom-vs-table th {
		min-width: 100px;
	}
	.custom-vs-table td {
		min-width: 100px;
	}
</style>